import React from 'react';
import GoogleMap, { Props as MapProps } from 'google-map-react';

import { LeafletMapOptions } from 'ha/types/LeafletMapOptions';
import { withIntl, IntlProps } from 'ha/i18n';
import { ConfigConsumer } from 'ha/helpers/config';
import pepitaMapLoader from './pepitaMapLoader';
import { useFeatureFlags } from 'ha/modules/FeatureFlags';

interface Props {
  bootstrapURLKeys?: {
    key: string;
    language: string;
  };
  onDrag?: () => void;
  children: React.ReactNode;
  options: MapProps['options'] | LeafletMapOptions;
}

const HaGoogleMap: React.FC<Props & IntlProps & MapProps> = ({
  bootstrapURLKeys = {},
  children,
  intl,
  ...rest
}) => {
  const { mapProvider } = useFeatureFlags();

  return (
    <ConfigConsumer>
      {config => (
        <GoogleMap
          {...rest}
          googleMapLoader={
            mapProvider === 'google' ? undefined : pepitaMapLoader
          }
          bootstrapURLKeys={{
            key:
              mapProvider === 'google'
                ? config.google.maps_key
                : config.immobiliare.maps_key,
            language: intl.locale,
            ...bootstrapURLKeys,
          }}
        >
          {children}
        </GoogleMap>
      )}
    </ConfigConsumer>
  );
};

export default withIntl(HaGoogleMap);
